import React from 'react';
import SponsorBar from "components/partials/sponser-bar";

// import helpers
import { isGatsbyImageData } from "helpers/is-gatsby-image";

// import types
import { SvgLogoImage } from "types/svg-logo-image";

const SponsorBarComponentBuilder: React.FC<{ sponsorBarData?: Queries.SponsorBarBlockFragment }> = ({ sponsorBarData }) => {

    if (!sponsorBarData) return null;

    let svgImage: SvgLogoImage | undefined = undefined;

    let sponsorBarImage = undefined;

    // use the sponsor's title
    let sponsorImageAlt = sponsorBarData.sponsor?.title || '';

    let textBefore: string | undefined = undefined;

    let textAfter: string | undefined = undefined;

    if (sponsorBarData.layoutOption === 'sponsored-by') {
        textBefore = 'Sponsored By';
    } else {
        textAfter = sponsorBarData.heading || '';
    }

    // try to get SVG Logo first
    if (sponsorBarData.sponsor?.svgLogo?.url) {

        svgImage = {
            url: sponsorBarData.sponsor.svgLogo.url,
            alt: sponsorBarData.sponsor.svgLogo.alt || '',
            height: sponsorBarData.sponsor.svgLogo.height || undefined,
            width: sponsorBarData.sponsor.svgLogo.width || undefined
        };
        
    } else if (sponsorBarData.sponsor?.image) {

        sponsorBarImage = isGatsbyImageData(sponsorBarData.sponsor?.image?.gatsbyImageData) ? sponsorBarData.sponsor?.image?.gatsbyImageData : undefined

    }

    return (
        <SponsorBar
            text_before={textBefore}
            text_after={textAfter}
            alt_text={sponsorImageAlt}
            image={sponsorBarImage}
            svgLogoImage={svgImage}
        />
    );

}

export default SponsorBarComponentBuilder;